import React from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import AppHeader from './shared/components/app-header/AppHeader';
import ErrorBoundary from './shared/components/app-error-boundary/ErrorBoundary';
import { registerInterceptor } from './api/apiUtils';
import CacheBuster from './CacheBuster';
import AppFooter from './shared/components/app-footer/AppFooter';
import AppConfirmationProvider from './shared/components/app-confirmation/AppConfirmationProvider';
import LanguageWrapper from './shared/hooks/languageWrapper';
import {
  getStringFromLS,
  getObjectFromLS,
} from './shared/helper-utils/localStorage';
import TimeoutProvider from './TimeoutProvider';
import PageSeo from './shared/components/app-seo/PageSeo';
import { APP_USER_AUTH, APP_USER_PROFILE } from './saas/AppStorageStaticNames';
import { useAppContext } from './saas/AppConfigWrapper';

function ConditionalFooter() {
  const { appConfig } = useAppContext();
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  const isVoyraClient = appConfig?.appDbName?.toLowerCase() === 'saas_voyrainr';
  if (isLoginPage && isVoyraClient) return null;
  return <AppFooter />;
}

function App() {
  const { appConfig } = useAppContext();

  const applyClientStyles = () => {
    const root = document.documentElement;
    Object.entries(appConfig).forEach(([key, value]) => {
      if (key.startsWith('primaryColor')) {
        root.style.setProperty(`--${key}`, value);
      }
      if (key.startsWith('secondaryColor')) {
        root.style.setProperty(`--${key}`, value);
      }
    });
  };
  applyClientStyles();

  const userAuth = getStringFromLS(APP_USER_AUTH);
  const userProfile = getObjectFromLS(APP_USER_PROFILE);

  return (
    <LanguageWrapper>
      <CacheBuster>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) return null;
          if (!loading && !isLatestVersion) {
            refreshCacheAndReload();
          }
          return (
            <TimeoutProvider>
              <ErrorBoundary>
                <AppConfirmationProvider>
                  <BrowserRouter>
                    <PageSeo />
                    {userAuth !== null && userProfile !== null && <AppHeader />}
                    <div className="app-main-content">
                      <AppRoutes />
                    </div>
                    <ConditionalFooter />
                  </BrowserRouter>
                </AppConfirmationProvider>
              </ErrorBoundary>
            </TimeoutProvider>
          );
        }}
      </CacheBuster>
    </LanguageWrapper>
  );
}

registerInterceptor();

export default App;
